import {
  nextStepHandler,
  fundingApproval,
  launchTask,
  saveProcessDraft,
  getTaskBusinessData,
  dispatchTask,
  needHelpPerson
} from '@/api/compositeAssit.js'
import store from '@/store'
import moment from 'moment'
import lodash from 'lodash'

function handleData(params = {}) {
  // formData
  const data = lodash.cloneDeep(params)
  let initData = {}
  if (data && data.pageType === 'launch') {
    console.log('拟稿发起')
    initData = lodash.cloneDeep(store.getters.initData)
  } else {
    initData = lodash.cloneDeep(store.getters.processData)
    console.log('重新发起')
  }
  let startTime = ''
  let endTime = ''
  const baseData = data.baseData
  const noticeReader = data.noticeReader
  if (baseData && baseData.date) {
    startTime = baseData.date[0] ? moment(baseData.date[0]._d).format('YYYY-MM-DD') : ''
    endTime = baseData.date[1] ? moment(baseData.date[1]._d).format('YYYY-MM-DD') : ''
  }
  initData.init_value.process_base_title = baseData.process_base_title
  delete baseData.date
  delete baseData.process_base_title
  initData.init_value.process_base_table_message = JSON.stringify(
    Object.assign(initData.init_value.process_base_table_message, {
      ...baseData,
      start_time: startTime,
      end_time: endTime,
      need_help_person: data.assitPeople
    })
  )
  // initData.init_value.process_base_drafter = JSON.stringify(initData.init_value.process_base_drafter)
  initData.process_config = data.leaderList
  initData.notice_reader = noticeReader
  initData.activity_volunteer = data.volunteer // 志愿者

  return initData
}
function approvalData(approvalInfo = {}) {
  // 处理审批数据
  const initData = lodash.cloneDeep(store.getters.processData)
  initData.init_value = Object.assign({}, initData.init_value, {
    process_base_approval: approvalInfo.result === '同意' ? '1' : '0',
    process_base_approval_opinion: approvalInfo.opinion
  })
  initData.init_value.process_base_table_message = JSON.stringify(
    initData.init_value.process_base_table_message
  )
  return initData
}
export const service = {
  nextStepHandler(data) {
    // 查找下一步处理人
    let params = {}
    if (data && data.pageType === 'approval') {
      // 当是审批提交查找下一步处理人的时候
      console.log('审批查找下一步处理人')
      params = approvalData(data.approvalInfo)
    } else {
      // 草稿，拟稿，重新发起
      console.log('发起查找下一步处理人')
      params = handleData(data)
    }
    return new Promise((resolve, reject) => {
      nextStepHandler(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  launchTask(data) {
    // 表单提交
    const params = handleData(data)
    return new Promise((resolve, reject) => {
      launchTask(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  saveProcessDraft(data) {
    // 保存流程
    const params = handleData(data)
    return new Promise((resolve, reject) => {
      saveProcessDraft(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTaskBusinessData(data) {
    // 获取流程业务数据
    const params = handleData(data)
    return new Promise((resolve, reject) => {
      getTaskBusinessData(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  dispatchTask(data) {
    // 处理表单
    let params = {}
    if (data.pageType === 'approval') {
      console.log('审批处理表单')
      params = approvalData(data.approvalInfo)
    } else {
      console.log('重新发起处理表单')
      params = handleData(data)
    }
    // initData.init_value.process_base_drafter = JSON.stringify(initData.init_value.process_base_drafter)
    return new Promise((resolve, reject) => {
      dispatchTask(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  needHelpPerson() {
    // 获取帮扶对象数据
    return new Promise((resolve, reject) => {
      needHelpPerson({ need_help_person_number_id: '' })
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  fundingApproval(type) {
    // 获取帮扶对象数据
    return new Promise((resolve, reject) => {
      const initData = lodash.cloneDeep(store.getters.processData)
      const approval = type ? 1 : 0
      initData.init_value.process_base_table_message = JSON.stringify(
        initData.init_value.process_base_table_message
      )
      initData.init_value.process_base_approval = approval
      fundingApproval(initData)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
